import React from 'react'
import Panel from 'src/Components/shared/Panel'
import { If, Unless } from 'src/Components'
import Loans from './Loans'
import EditLoan from './EditLoan'
import EditBalance from './EditBalance'

const MortgagesPanel = ({ editing, editingBalance, showPast, setShowPast }) => (
  <Panel data-qa='MortgagesCard'>
    <If condition={editing}>
      <EditLoan />
    </If>
    <If condition={editingBalance}>
      <EditBalance />
    </If>
    <Unless condition={editing || editingBalance}>
      <Loans showPast={showPast} setShowPast={setShowPast} />
    </Unless>
  </Panel>
)

export default MortgagesPanel
